"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = presetMap;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _mapCartShippingFixPrice = _interopRequireDefault(require("./mapCartShippingFixPrice"));

var _mapCartGiftMod = _interopRequireDefault(require("./mapCartGiftMod"));

var _mapSubjectSale = _interopRequireDefault(require("./mapSubjectSale"));

var _mapSubjectPercentDiscount = _interopRequireDefault(require("./mapSubjectPercentDiscount"));

var _mapSubjectIndirectPercentDiscountIfAs = _interopRequireDefault(require("./mapSubjectIndirectPercentDiscountIfAs"));

var _mapSubjectSelfAsGift = _interopRequireDefault(require("./mapSubjectSelfAsGift"));

var _mapSubjectQuantityDiscount = _interopRequireDefault(require("./mapSubjectQuantityDiscount"));

var _mapSubjectQuantityDiscountByPriceGroup = _interopRequireDefault(require("./mapSubjectQuantityDiscountByPriceGroup"));

var _mapSubjectSingleProductMultipleGifts = _interopRequireDefault(require("./mapSubjectSingleProductMultipleGifts"));

function presetMap(extenstion) {
  return (0, _extends2.default)({
    // for cart
    cartShippingFixPrice: _mapCartShippingFixPrice.default,
    cartGiftMod: _mapCartGiftMod.default,
    // for subject
    subjectIndirectPercentDiscountIf: _mapSubjectIndirectPercentDiscountIfAs.default,
    subjectSale: _mapSubjectSale.default,
    subjectPercentDiscount: _mapSubjectPercentDiscount.default,
    subjectSelfAsGift: _mapSubjectSelfAsGift.default,
    subjectQuantityDiscount: _mapSubjectQuantityDiscount.default,
    subjectQuantityDiscountByPriceGroup: _mapSubjectQuantityDiscountByPriceGroup.default,
    subjectSingleProductMultipleGifts: _mapSubjectSingleProductMultipleGifts.default
  }, extenstion);
}